import React from 'react';
import { ArrowLeft } from 'phosphor-react';
import { Button } from '@material-ui/core';
import Router from 'next/router';

interface Props {
  goBack?: Function;
}
const BackButton = (props: Props) => {
  const handleClick = () => {
    if (window.history.length === 1) {
      return Router.push('/dashboard');
    }
    props.goBack ? props.goBack() : Router.back();
  };
  return (
    <Button onClick={handleClick} style={{ minWidth: 0 }}>
      <ArrowLeft size={32} color="#463264" />
    </Button>
  );
};

export default BackButton;
